import React from 'react';
import { useLang } from './LanguageContext';
import t from './translations';
import './Skills.css';

const Skills = () => {
  const { lang } = useLang();
  const { skills } = t[lang];

  return (
    <section id="skills" className="skills-section">
      <h2 className="work-heading">{skills.heading}</h2>
      <div className="skills-grid">
        {skills.groups.map((group, i) => (
          <div key={i} className="skills-group">
            <h4 className="skills-category">{group.category}</h4>
            <div className="skills-badges">
              {group.items.map((skill, j) => (
                <span key={j} className="skill-badge">{skill}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
